/**
 * Procedure Categories and Procedures for MD in Immunohematology & Blood Transfusion students
 * Extracted with strict evidence from official NMC PDF
 */
export const IMMUNOHEMATOLOGY_MD_PROCEDURES = {
  "Blood Grouping & Serological Compatibility": [
    "ABO & Rh D Forward and Reverse Grouping (Tube & Gel Card)",
    "Cross-Matching (Tube, Gel Card, and Automated Methods)",
    "Direct and Indirect Antiglobulin Test (DAT & IAT / Coomb's Test)",
    "Antibody Screening & Identification using Red Cell Panels",
    "Antibody Titration (Anti-D, Anti-A, Anti-B)",
    "Red Cell Elution, Adsorption, and Minor Blood Group Typing",
    "Saliva Inhibition Test & ABO Discrepancy Resolution",
  ],
  "Blood Donation, Phlebotomy & Apheresis": [
    "Donor Selection, Eligibility Screening & Phlebotomy Site Preparation",
    "Whole Blood Collection & Donor Care",
    "Preparation of Blood Components (PRBC, FFP, Platelet Concentrates, Cryoprecipitate)",
    "Plateletpheresis & Plasmapheresis (Donor & Therapeutic Apheresis)",
    "Therapeutic Plasma Exchange (TPE) & Cell Saver Blood Salvage",
  ],
  "Transfusion Transmissible Infection (TTI) Screening": [
    "TTI Donor Screening (ELISA, Rapid, NAT / PCR, TMA)",
    "Syphilis Serological Testing (VDRL / RPR / TPHA)",
    "Peripheral Blood Smear Staining & Malarial Parasite Screening",
  ],
  "Coagulation & Molecular Diagnostics": [
    "Complete Hemogram & Peripheral Blood Smear Staining",
    "Coagulation Testing (PT, APTT, Fibrinogen, Thrombin Time, Mixing Studies)",
    "Thromboelastography (TEG / ROTEM) Point-of-Care Testing",
    "Manual and Automated Nucleic Acid Extraction (DNA / RNA)",
    "HLA Typing & CDC Cross-Match / Flow Cytometry Cross-Matching",
  ],
};

export const IMMUNOHEMATOLOGY_MD_CATEGORIES = Object.keys(IMMUNOHEMATOLOGY_MD_PROCEDURES);

export const isMDInImmunohematologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("md") || d.includes("master")) &&
    (d.includes("immunohematology") ||
      d.includes("immunohaematology") ||
      d.includes("transfusion"))
  );
};
